(function () {
  'use strict';

  if (window.IACuratedBasket) return;

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function sectionsToRender(cart) {
    if (cart && typeof cart.getSectionsToRender === 'function') {
      return cart.getSectionsToRender().map(function (section) { return section.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function publishUpdate(items, data) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) {
      return Promise.resolve();
    }
    var firstVariant = items.length ? String(items[0].id) : '';
    return Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'ia-curated-basket',
      productVariantId: firstVariant,
      variantId: firstVariant,
      cartData: data
    }));
  }

  function endpoint() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart/add.js';
    }
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;
    return '/cart/add.js';
  }

  function addItems(items, activeElement) {
    var cart = drawer();
    var body = { items: items };
    if (cart) {
      body.sections = sectionsToRender(cart);
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(activeElement);
    }

    return fetch(endpoint(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'The table could not be added.');
        }
        return data;
      });
    }).then(function (data) {
      return publishUpdate(items, data).then(function () {
        if (cart && data.sections && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(data);
        }
        return data;
      });
    });
  }

  function parseItems(basket) {
    var payload = basket.querySelector('[data-ia-basket-items]');
    if (!payload) return [];
    try {
      var items = JSON.parse(payload.textContent || '[]');
      return items.filter(function (item) {
        return item && Number(item.id) > 0 && Number(item.quantity) > 0;
      }).map(function (item) {
        return { id: Number(item.id), quantity: Number(item.quantity) };
      });
    } catch (error) {
      console.error('Curated basket data could not be read.', error);
      return [];
    }
  }

  function setStatus(basket, message) {
    var status = basket.querySelector('[data-ia-basket-status]');
    if (status) status.textContent = message;
  }

  function handleAdd(button) {
    var basket = button.closest('[data-ia-curated-basket]');
    if (!basket || button.disabled) return;

    var items = parseItems(basket);
    if (!items.length) {
      setStatus(basket, 'These products are currently unavailable. Please review the individual picks below.');
      return;
    }

    var originalLabel = button.dataset.originalLabel || button.textContent.trim();
    button.dataset.originalLabel = originalLabel;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.remove('is-added', 'is-error');
    button.textContent = 'Adding the table…';
    setStatus(basket, 'Adding ' + items.length + ' items to your cart.');

    addItems(items, button).then(function () {
      button.textContent = 'Table added';
      button.classList.add('is-added');
      setStatus(basket, 'Added to your cart.');
      window.setTimeout(function () {
        button.textContent = originalLabel;
        button.classList.remove('is-added');
        setStatus(basket, '');
      }, 2600);
    }).catch(function (error) {
      console.error('Curated basket add failed.', error);
      button.textContent = 'Try again';
      button.classList.add('is-error');
      setStatus(basket, error.message || 'The table could not be added. Please try again.');
      window.setTimeout(function () {
        button.textContent = originalLabel;
        button.classList.remove('is-error');
        setStatus(basket, '');
      }, 5200);
    }).finally(function () {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ia-basket-add]');
    if (!button) return;
    event.preventDefault();
    handleAdd(button);
  });

  window.IACuratedBasket = {
    addItems: addItems,
    parseItems: parseItems
  };
})();
